import React from 'react'
import { Modal, Button } from 'react-bootstrap'

export default class DownloadModal extends React.Component {
  constructor(props) {
    super(props)
    this.handleShow = this.handleShow.bind(this)
    this.handleHide = this.handleHide.bind(this)
    this.handleModal = this.handleModal.bind(this)
    this.state = {show: false}
  }

  handleModal(){
    this.handleHide()
    this.props.export()
  }

  handleHide() {
    this.setState({ show: false })
  }

  handleShow() {
    this.setState({ show: true })
  }

  render() {
    return (
      <div>
         <Button  className='downloaden' onClick={this.handleShow}>
          {this.props.textbtn}
        </Button>
        <Modal
          {...this.props}
          show={this.state.show}
          onHide={this.handleHide}
          dialogClassName="custom-modal"
          backdrop={false}>
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-lg">
              {this.props.title}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p dangerouslySetInnerHTML={{ __html: this.props.text }}></p>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="primary" onClick={this.handleModal}>{this.props.modalbtntext}</Button>
            <Button onClick={this.handleHide}>Annuleren</Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/DownloadModal.js